export default {
  root: {
    fontFamily: 'body',
    // body: {
      overflowX: 'hidden',
      position: 'relative',
      minHeight: '100vh',
      backgroundColor: 'background',
      backgroundImage: 'url(/bg.svg)',
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'contain',
      backgroundPosition: 'top center',
      // height: '100%',
    // },
    color: 'white',
    a: {
      color: 'inherit',
    },
  },
};
